/**
 * datetime — shared datetime-local → ISO-UTC conversion (lifted out of
 * ClubHub.jsx for slice 3 so SeasonTraining can use the same rule).
 *
 * Postgres TIMESTAMPTZ interprets timezone-less strings as UTC, which shifts
 * UK summer times by an hour — every datetime-local value MUST go through
 * this before hitting the API (feedback_marakin_datetime_local).
 */

// "YYYY-MM-DDTHH:MM" (browser-local) → "YYYY-MM-DDTHH:MM:00.000Z".
// Idempotent: values already carrying 'Z' or a numeric offset pass through.
export const toIsoUtc = (val) => {
  if (!val) return val;
  if (typeof val !== 'string') return val;
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(val)) return val;
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return val;
  return d.toISOString();
};
